import { connect } from "react-redux";

import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withViewModelSelect } from "../../withViewModelSelect";
import { AttachInfo } from "../../../../../Common/CandyApiClient/Types/Attachments/Attacments";

import { EmbeddedLog } from "./EmbeddedLog";

export interface EmbeddedLogContainerProps {
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: EmbeddedLogContainerProps) => {
    const attachments = Object.values(state.attachments.byId);
    const isAllAttachmentsLoadedOrHasErrors = attachments
        .filter(isNotNullOrUndefined)
        .filter(x => isAttachmentUsed(x, ownProps.viewModelSelect, state))
        .every(x => isAttachmentLoadedOrHasError(x, state, ownProps.viewModelSelect));
    return {
        useExtendedErrorLog: state.settings.useExtendedErrorLog,
        hasNotLoadedAttachments: !isAllAttachmentsLoadedOrHasErrors,
        allowSend: state.settings.isFormInFormNds || state.settings.allowsend,
        canCheckByPopd: state.settings.canCheckByPopd,
        isDisabledCloseAndSaveButton: state.settings.isDisabledCloseAndSaveButton,
        needShowNdsSverka:
            (attachments.length > 0 && state.settings.isFormInFormNds && state.settings.isNeedNdsRevise) || false,
    };
};

export const EmbeddedLogContainer = withViewModelSelect(connect(mapStateToProps)(EmbeddedLog));

function isAttachmentLoadedOrHasError(
    attachmentInfo: AttachInfo,
    state: FullFormState,
    viewModelSelect: ViewModelSelect
): boolean {
    return isAttachmentLoaded(attachmentInfo) || isAttachmentHasErrorOrWarning(attachmentInfo, viewModelSelect, state);
}

function isAttachmentLoaded(attachmentInfo: AttachInfo): boolean {
    return attachmentInfo.meta.progress != undefined && Number(attachmentInfo.meta.progress) >= 100;
}

function isAttachmentUsed(attachmentInfo: AttachInfo, viewModelSelect: ViewModelSelect, state: FullFormState): boolean {
    const bindingPath = attachmentInfo.meta.pathToAttachment;
    if (bindingPath == undefined) {
        return false;
    }
    const viewModel = viewModelSelect.pathViewModel(state, bindingPath);
    return viewModel.value === attachmentInfo.id;
}

function isAttachmentHasErrorOrWarning(
    attachmentInfo: AttachInfo,
    viewModelSelect: ViewModelSelect,
    state: FullFormState
): boolean {
    const bindingPath = attachmentInfo.meta.pathToAttachment;
    if (bindingPath == undefined) {
        return false;
    }
    const viewModel = viewModelSelect.pathViewModel(state, bindingPath);
    return (viewModel.error?.length ?? 0) > 0 || (viewModel.warning?.length ?? 0) > 0;
}
